export default __webpack_public_path__ + "static/media/demo-3-raw.73051ea5.jpg";